module.exports = __webpack_public_path__ + "static/img/rar.42fe601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/rar.png
// module id = j+XP
// module chunks = 53